import services from 'services/services';
import * as types from '../types';
import { setRequestUrl } from 'store/actions';

// Import helpers
import {
	checkFetchErrors,
	queryParams
} from '../helpers_actions/convert_helpers';

// Import variables
import { TABLE_LENGTH } from 'components/helpers/table';

// ******************** FETCH PASS PRICES - TABLE DATA ********************
export const fetchPassPrices = (options, itemId) => async (
	dispatch,
	getState
) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.FETCH_PASS_PRICES_LOADING,
			payload: true
		});

		const {
			passes: {
				prices: {
					columns,
					options: { startIndex: startTableIndex, page }
				}
			}
		} = getState();

		const startIndex =
			options.page === page ? startTableIndex : options.startIndex;

		const url = `/timetables/prices/listByProduct/pass/${itemId}?${queryParams(
			options,
			TABLE_LENGTH,
			columns,
			startIndex
		)}`;

		const { data } = await services.get(url);

		// Calculate pages
		const pages = Math.ceil(data.recordsFiltered / TABLE_LENGTH);

		// // Dispatch an action with data
		dispatch({
			type: types.FETCH_PASS_PRICES_SUCCESS,
			payload: { ...data, pages, page: options.page, startIndex }
		});

		// save request url in redux
		setRequestUrl(url)(dispatch);
	} catch (error) {
		dispatch({
			type: types.FETCH_PASS_PRICES_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};

// ******************** DELETE PASS PRICE ********************
export const deletePassPrice = (id) => async (dispatch) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.DELETE_PASS_PRICE_LOADING,
			payload: true
		});

		await services.delete(`/timetables/prices/${id}`);
		// Dispatch an action with data
		dispatch({
			type: types.DELETE_PASS_PRICE_SUCCESS,
			payload: true
		});
	} catch (error) {
		// Dispatch an action with error set to true
		dispatch({
			type: types.DELETE_PASS_PRICE_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};
